import React, { createContext, useState, useContext, useEffect, useRef } from 'react';

const GameStateContext = createContext();

export const GameStateProvider = ({ children }) => {
    // Game state variables
    const [scraps, setScraps] = useState(0);
    const [planks, setPlanks] = useState(0);
    const [inventory, setInventory] = useState([]);
    const [playerName, setPlayerName] = useState("");
    const [axeHitPoints, setAxeHitPoints] = useState();
    const backgroundColors = ['#FF973E', '#D2C4E0', '#E7D6A4', '#AA704A', '#D2FDFF', '#455155', '#5D7D86'];
    const [backgroundColor, setBackgroundColor] = useState(backgroundColors); 
    
    // Music control states
    const [isMuted, setIsMuted] = useState(false);
    const [volume, setVolume] = useState(0.5);
    const musicTrack = useRef(new Audio('/Music.mp3')); // Path to your music file in public folder

    const startMusic = () => {
        setIsMuted(false); // Unmutes the music
        if (musicTrack.current) {
            musicTrack.current.play().catch(error => {
                console.error('Error occurred while trying to play music:', error);
            });
        }
    };

    // Effect for controlling music playback and volume
    useEffect(() => {
        musicTrack.current.volume = volume;
        musicTrack.current.loop = true; // Music will loop continuously

        if (isMuted) {
            musicTrack.current.pause();
        }
    }, [isMuted, volume]);

    // Function to add items to inventory
    const addToInventory = (item) => {
        setInventory(currentInventory => [...currentInventory, item]);
    };

    // Function to buy an axe
    const buyAxe = (type) => {
        let cost = type === 'Metal' ? 7 : 2;
        let hitPoints = type === 'Metal' ? 7 : 3;

        if (scraps >= cost) {
            setScraps(currentScraps => currentScraps - cost);
            addToInventory({ type: type, hitPoints: hitPoints });
        } else {
            console.log(`Not enough scraps to buy a ${type} Axe.`);
        }
    };

    // Function to repair an axe
    const repairAxe = () => {
        if (scraps >= 3 && inventory.some(axe => axe.type === 'Wooden')) {
            setScraps(currentScraps => currentScraps - 3);
            setAxeHitPoints(3); // Resets hit points of a wooden axe
        } else if (scraps >= 3 && inventory.some(axe => axe.type === 'Metal')) {
            setScraps(currentScraps => currentScraps - 3);
            setAxeHitPoints(7); // Resets hit points of a metal axe
        } else {
            console.log("Not enough scraps to repair the axe.");
        }
    };

    // Function to equip a specific axe from the inventory
    const equipAxe = (axeType) => {
        const axe = inventory.find(item => item.type === axeType);
        if (axe) {
            setAxeHitPoints(axe.hitPoints);
        } else {
            console.log(`No ${axeType} Axe available to equip.`);
        }
    };

    // Providing the context values
    return (
        <GameStateContext.Provider value={{
            scraps, setScraps,
            planks, setPlanks,
            inventory,             setInventory,
            playerName, setPlayerName,
            axeHitPoints, setAxeHitPoints,
            backgroundColor, setBackgroundColor, // Added background color state
            buyAxe, repairAxe, equipAxe,
            isMuted, setIsMuted,
            volume, setVolume,
            startMusic
        }}>
            {children}
        </GameStateContext.Provider>
    );
};

export const useGameState = () => useContext(GameStateContext);

export default GameStateProvider;

